import type { OrderCalculation } from '../../../types/order-calculation';
import type { TicketOfficeView } from '../../../types/ticket-office';

export const updateCalc = (view: TicketOfficeView, calc: OrderCalculation) => {
    const { state, update } = view;

    // The response of an earlier update may arrive later than one for
    // a more recent update, especially when updating seats in bulk.
    // We want to discard older data if we already have newer values.
    if (!state.calc || calc.timestamp > state.calc.timestamp) {
        state.calc = calc;
        update();
    }
}
